"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var PromoCodeTemplateCodesListCtl = /** @class */ (function (_super) {
    __extends(PromoCodeTemplateCodesListCtl, _super);
    function PromoCodeTemplateCodesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_promo_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.promo_code; });
        _this.dk_is_used = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_used; });
        _this.dk_is_reserved = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_reserved; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_activated_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.activated_count; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this.dk_pprogram_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.pprogram_title; });
        _this.dk_partner_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.partner_login; });
        _this.dk_offer_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.offer_title; });
        _this.dk_tracker_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.tracker_title; });
        _this.dk_is_can_expire = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_can_expire; });
        _this.dk_expire_year = UIUtils_1.UIUtils.IProp2Str(function (o) { o.expire_year; });
        _this.dk_expire_month = UIUtils_1.UIUtils.IProp2Str(function (o) { o.expire_month; });
        _this.dk_expire_day = UIUtils_1.UIUtils.IProp2Str(function (o) { o.expire_day; });
        _this._errDialog = errDialog;
        return _this;
    }
    PromoCodeTemplateCodesListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    PromoCodeTemplateCodesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "object with id [" + id + "] not found !";
    };
    PromoCodeTemplateCodesListCtl.prototype.LoadData = function (promoTypeId, onDone) {
        var _this = this;
        webAApi_1.ListPromoCodeTemplateCodesByPromoCodeTemplateIdGet.exec({
            promocode_template_id: promoTypeId
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    activated_count: resp.list[i].activated_count,
                    is_reserved: resp.list[i].is_reserved,
                    is_used: resp.list[i].is_used,
                    promo_code: resp.list[i].promo_code,
                    is_locked: resp.list[i].is_locked,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    description: resp.list[i].description,
                    pprogram_title: resp.list[i].pprogram_title,
                    partner_login: resp.list[i].partner_login,
                    offer_title: resp.list[i].offer_title,
                    tracker_title: resp.list[i].tracker_title,
                    is_can_expire: resp.list[i].is_can_expire,
                    expire_year: resp.list[i].expire_year,
                    expire_month: resp.list[i].expire_month,
                    expire_day: resp.list[i].expire_day
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PromoCodeTemplateCodesListCtl.prototype.ExportData = function (promoTypeId, onDone) {
        var _this = this;
        webAApi_1.ListPromoCodeTemplateCodesByPromoCodeTemplateIdGet.exec({
            promocode_template_id: promoTypeId
        }, function (resp) {
            var data = [];
            for (var i = 0; i < resp.list.length; i++) {
                data.push({
                    code: resp.list[i].promo_code,
                    description: resp.list[i].description,
                    partner: resp.list[i].partner_login,
                });
            }
            _this.Update();
            if (onDone) {
                onDone(data);
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PromoCodeTemplateCodesListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    PromoCodeTemplateCodesListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeletePromoCodeTemplateCode.exec({
                data: {
                    promocode_template_code_id: key
                }
            }, function (resp) {
                _this.RemoveItem(key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PromoCodeTemplateCodesListCtl.prototype.SetIsLocked = function (key, IsLocked, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetPromoCodeTemplateCodeIsLocked.exec({
                data: {
                    promocode_template_code_id: key,
                    locked: IsLocked
                }
            }, function (resp) {
                _tmp.is_locked = IsLocked;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PromoCodeTemplateCodesListCtl.prototype.SetIsReserved = function (key, IsReserved, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetPromoCodeTemplateCodeIsReserved.exec({
                data: {
                    promocode_template_code_id: key,
                    reserved: IsReserved
                }
            }, function (resp) {
                _tmp.is_reserved = IsReserved;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PromoCodeTemplateCodesListCtl.prototype.SetDescription = function (key, Description, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetPromoCodeTemplateCodeDescription.exec({
                data: {
                    promocode_template_code_id: key,
                    description: Description
                }
            }, function (resp) {
                _tmp.description = Description;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PromoCodeTemplateCodesListCtl.prototype.SetPartner = function (key, pprogram, partner, offer, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoBindPromoCodeTemplateCodeToPartner.exec({
                data: {
                    promocode_template_code_id: key,
                    pprogram_id: pprogram,
                    usr_partner_id: partner,
                    partner_offer_id: offer
                }
            }, function (resp) {
                _tmp.pprogram_title = resp.pprogram_title;
                _tmp.partner_login = resp.partner_login;
                _tmp.offer_title = resp.offer_title;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PromoCodeTemplateCodesListCtl.prototype.SetExpirationParams = function (key, IsCanExpire, Year, Month, Day, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetPromoCodeTemplateCodeExpireParams.exec({
                data: {
                    promocode_template_code_id: key,
                    is_can_expire: IsCanExpire,
                    expire_year: Year,
                    expire_month: Month,
                    expire_day: Day
                }
            }, function (resp) {
                _tmp.is_can_expire = IsCanExpire;
                _tmp.expire_year = Year;
                _tmp.expire_month = Month;
                _tmp.expire_day = Day;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PromoCodeTemplateCodesListCtl.prototype.DoGeneratePromoCodes = function (data, onDone) {
        var _this = this;
        webAApi_1.DoGeneratePromoCodeTemplateCodes.exec({
            data: {
                promocode_template_id: data.promoCodeTemplateId,
                promocode_codes_count: data.generateCount,
                description: data.dscription,
                is_bind_partner: data.isBindPartner,
                pprogram_id: data.pprogramId,
                usr_partner_id: data.usrPartnerId,
                partner_offer_id: data.partnerOfferId
            }
        }, function (resp) {
            if (onDone) {
                onDone(resp.generated_count);
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PromoCodeTemplateCodesListCtl.prototype.DoGenerateOnePromoCode = function (promoCodeTemplateId, promoCode, Description, onDone) {
        var _this = this;
        webAApi_1.DoGeneratePromoCodeTemplateUniqueCode.exec({
            data: {
                promocode_template_id: promoCodeTemplateId,
                promocode_code: promoCode,
                description: Description
            }
        }, function (resp) {
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return PromoCodeTemplateCodesListCtl;
}(BaseController_1.BaseController));
exports.PromoCodeTemplateCodesListCtl = PromoCodeTemplateCodesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_promocodes/ctl/PromoCodeTemplateCodesListCtl.ts
// module id = 881
// module chunks = 0